import { Analytics } from '../service/Analytics';
import { ConsoleDebug } from '../../../_utils/ConsoleDebug';
import { RedfactHelper } from "../../../_utils/RedfactHelper";

// Wurde ausgebaut am 11.04.22: SP-592, neue Trackingvariante aktiviert
//import { Ivw } from '../service/Ivw';
import { IvwUpdate } from '../service/IvwUpdate';
// import { Optimize } from '../service/Optimize'; - wurde am 30.09 von Google abgeschalten
import { GoogleTagManager } from '../service/GoogleTagManager';
import { FacebookPixel } from '../service/FacebookPixel';
import { Mouseflow } from '../service/Mouseflow';
import { Kilkaya } from '../service/Kilkaya';
import { Taboola } from "../service/Taboola";
import { Cleverpush } from "../service/Cleverpush";
import { Smartbanner } from "../service/Smartbanner";
import { Piano } from "../service/Piano";
import { PianoAnalytics } from "../service/PianoAnalytics";

const CTXT_KEY_EVENT_CMP_LIVE = 'event:cmp_live';
const CTXT_KEY_EVENT_PIANO_CONSENT_LIVE = 'event:piano_consent_live';


export class Action {

  run() {
    this.logInstance = new ConsoleDebug('debug-tracking', 'Tracking');
    this.context.on(CTXT_KEY_EVENT_CMP_LIVE, (event) => {
      this.logInstance.log('CMP is nun live, starte Tracking', event)
      this.loadTracking();
    })
  }

  loadTracking() {
    this.obj = this;
    this.redfacthelper = new RedfactHelper();

    this.logInstance.log('Component live');

    // cmp in redFACT active?
    if (!this.redfacthelper.checkBackendApproval('tool_cmp')) {
      this.logInstance.log('CMP was deactivated');
      return false;
    }

    this.logInstance.log('CMP is active via Backoffice');
    this.cmpObj = this.context.values.get('cmp:settings').cmp;
    this.logInstance.log('Context / cmp:settings: ', this.cmpObj);
    this.hasAccess = this.context.values.get('cmp:hasAccess').hasAccess;
    // Creating tracking service objects
    // const optimizeObj = new Optimize(); wurde am 30.09 von Google abgeschalten
    const googleTagManagerObj = new GoogleTagManager();
    const analytics = new Analytics();
    const fbPixel = new FacebookPixel();
    const ivwUpdate = new IvwUpdate();
    const mouseflow = new Mouseflow();
    const taboola = new Taboola();
    const kilkaya = new Kilkaya();
    const cleverpush = new Cleverpush();
    const smartbannerService = new Smartbanner();
    const pianoAnalytics = new PianoAnalytics(this.context);
    const piano = new Piano(this.context, this.cmpObj);

    // Piano Consent Modes
    window.pdl = window.pdl || {};
    window.pdl.requireConsent = "v2";
    window.pdl.consent = {};
    window.pdl.consent.products = ["COMPOSER", "PA", "VX", "DMP", "ESP"];

    window.pdl.consent_items = {
      PA: {
        properties: {
          article_id: "mandatory",
          content_article_name: "mandatory",
          content_authors: "mandatory",
          content_category: "mandatory",
          content_copyright: "mandatory",
          content_description: "mandatory",
          content_format: "mandatory",
          content_keywords: "mandatory",
          content_lifetime: "mandatory",
          content_modified_at: "mandatory",
          content_plus: "mandatory",
          content_publication_date: "mandatory",
          content_source: "mandatory",
          content_target_group: "mandatory",
          content_title: "mandatory",
          content_tonality: "mandatory",
          content_type: "mandatory",
          content_update_date: "mandatory",
          content_user_need: "mandatory",
          length: "mandatory",
          page_content_layout: "mandatory",
          region: "essential",
          retresco_organisation: "mandatory",
          retresco_ort: "mandatory",
          retresco_schlagwort: "mandatory",
          retresco_themenbereich: "mandatory",
          steuertags: "mandatory",
          paywall_display: "mandatory",
        },
      },
     };

    // LocalStore Eintrag wird als Flag benötigt, um zu Checken ob User sich auf der /login Page eingeloggt hat
    // Auf dieser Page steht das CMP und das Tracking nicht zur Verfuegung, weswegen das OptIn nach Login nach-
    // gelagert gesetzt werden muss
    // ID auf Zeile 94 muss noch refactort werden
    if(localStorage.getItem('setPianoOptIn') === "true") {
      this.logInstance.log('consentState localStorage setPianoOptIn: ', localStorage.getItem('setPianoOptIn'));
      window.__cmp('setVendorConsent',['c74553', 1 ]);
    }

    // no consent but backend approval necessary for these services
    this.firstPartyServices = [kilkaya, piano];

    this.firstPartyServices.forEach((service) => {
      if (this.redfacthelper.checkBackendApproval(service.getToolToken())) {
        service.load();
      } else {
        this.logInstance.log(service.getToolToken() + ' globally disabled in publication settings (redFACT)')
      }
    })

    // Wird seperat initializiert, da zu erst die Consentmodis von Piano gesetzt werden müssen in checkAndSetConsent();
    this.context.on(CTXT_KEY_EVENT_PIANO_CONSENT_LIVE, (event) => {
      pianoAnalytics.load();
      this.context.off(CTXT_KEY_EVENT_PIANO_CONSENT_LIVE);
    })

    smartbannerService.load();
    // array with tracking serivce objects for consent checks
    this.serviceConsentObjs = [googleTagManagerObj, analytics, fbPixel, mouseflow, taboola, cleverpush];

    // Check if cmt object exists
    this.logInstance.log('__cmp Object ist da');
    this.logInstance.log('__tcfapi: ' + window.__tcfapi);

    // Jede Interaktion mit dem CMP Layer triggered diese Funktion.
    // Diese Funktion ist ein Eventlistener für jeden Aufruf bzw. Änderung mit dem CMP
    window.__tcfapi("addEventListener",2, () => {
      this.checkConsents();

      // Das TP-Objekt muss erst vollständig da sein, da sonst die Consentmodis ins leere laufen.
      tp = window["tp"] || [];
      tp.push(["init", function() {
        piano.checkAndSetConsent();
      }]);

      if(analytics.isLoaded()) {
        // GA Ereignisse
        this.obj.addEvent('sharing', 'share', analytics);
        this.obj.addEvent('topic-navigation', 'click', analytics);
        this.obj.addEvent('top-navigation', 'click', analytics);
        this.obj.addEvent('domain-navigation', 'click', analytics);
        this.obj.addEvent('Footer', 'click', analytics);
        this.obj.addEvent('Teaser-xl-article-default', 'click', analytics);
        this.obj.addEvent('Teaser-l-article-default', 'click', analytics);
        this.obj.addEvent('Teaser-m-article-default', 'click', analytics);
        this.obj.addEvent('Teaser-s-article-default', 'click', analytics);
        this.obj.addEvent('Teaser-xs-article-default', 'click', analytics);
        this.obj.addEvent('sticky-banner', 'click', analytics);
      }
    });

    // Check if ivw_cfg redfact obj exists to trigger ivw tracking
    if (typeof window.ivw_cfg === 'object') {
      //ivw.load(window.ivw_cfg); // standard ivw tracking
      ivwUpdate.load(window.ivw_cfg); // new ivw tracking 2022.
    }

    this.cmpObj.hideEmbedConsentBar(this.hasAccess)
  }

  // Eventtracking from espi
  addEvent(category, action, analytics) {
    this.context.on(`${category}:${action}`, (event) => {
      const { target } = event.data;
      analytics.trackEvent(category, action, target);
    });
  }

  checkConsents() {
    this.logInstance.log('__tcfapi Event was triggered');
    this.serviceConsentObjs.forEach( (item) => {
      if(this.redfacthelper.checkBackendApproval(item.getToolToken())) {
        this.logInstance.log('Backend Approval was given => Token: ' + item.getToolToken());
        this.cmpObj.checkServiceConsent(item.getCmtId(), item);
      } else {
        this.logInstance.log('Backend Approval was NOT given => Token: ' + item.getToolToken());
      }
    });
    return true;
  }
}
